import axios from 'axios';

export default class UploadSpeed {
  async getUploadSpeed() {
    const uploadPostUrl = process.env.REACT_APP_UPLOAD_SPEED_POST_URL as string;

    let sampleData = '';
    for (let i = 0; i < 1024; i += 1) {
      sampleData += 'k';
    }

    const startTime = new Date().getTime();

    const response = await axios.post(
      uploadPostUrl,
      {
        uploadData: sampleData
      }
    );

    if (response.status !== 200) {
      return null;
    }

    const endTime = new Date().getTime();
    const duration = (endTime - startTime) / 1000;
    const speedKbps = 1024 / duration;
    const speedMbps = speedKbps / 1024;

    return speedMbps.toFixed(2);
  }
}
